import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="relative flex min-h-screen w-full flex-col items-center justify-center overflow-hidden bg-background-50 px-4 text-center">
      <span
        aria-hidden="true"
        className="absolute text-[10rem] font-black leading-none text-background-200 select-none md:text-[16rem]"
      >
        404
      </span>
      <div className="relative z-10">
        <span className="flex h-16 w-16 mx-auto items-center justify-center rounded-full bg-primary-100 text-primary-600">
          <i className="ri-emotion-sad-line text-4xl"></i>
        </span>
        <h1 className="mt-5 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
          这个瓜翻遍了瓜田也没找到
        </h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
          你访问的页面不存在，或者已经被我们整理下架了。回围观现场看看今天有什么新鲜事吧。
        </p>
        <div className="mt-6 flex flex-col justify-center gap-3 sm:flex-row">
          <Link
            to="/"
            className="inline-flex items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-4-line mr-1.5 text-base"></i>
            回到围观现场
          </Link>
          <Link
            to="/events"
            className="inline-flex items-center justify-center whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-3 text-sm font-semibold text-foreground-900 transition-colors hover:bg-background-100"
          >
            逛逛瓜田广场
          </Link>
        </div>
      </div>
    </div>
  );
}